import React from 'react'
import { ButtonComponent, GeneralAppointment } from 'tutorapp-components'
import { useNavigate, useLocation } from 'react-router-dom'


export default function GeneralAppointmentscreen() {

  const location = useLocation();
  const { appointmentData = {} } = location.state || {};


  const navigate = useNavigate()

  const onarrowclick = () => {
    navigate("/editAppointment")
  }
  const ondelete = () => {
    console.log('deleteclick')
  }
  const icons = {
    backarrow: "./images/ic_back.svg",
    subjectIcon: "./images/ic_subject.svg ",
    enrollmentIcon: "./images/ic_enrollment.svg ",
    hoursIcon: "./images/ic_remaining_hours.svg",
    studentIcon: "./images/ic_student.svg",
    rightchevron: "./images/ic_right.svg"

  };


  return (
    <div><GeneralAppointment handleEditGeneral={onarrowclick} ondelete={ondelete} generaldata={appointmentData} icons={icons}
    />
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ width: "360px", marginBottom: 10 }}>
          <ButtonComponent
            label="Save"
            style={{ backgroundColor: "#000", paddingVertical: 12 }}
            textStyle={{ color: "#fff" }}
          />
        </div>

        <div style={{ width: "360px" }}>
          <ButtonComponent
            label="Cancel"
            style={{ backgroundColor: "#ffff", paddingVertical: 12 }}
            textStyle={{ color: "#000" }}
          />
        </div>
      </div>




    </div>



  )
}
